export const employmentOptions = [
  'Employed',
  'Self-Employed',
  'Unemployed',
  'Student',
  'Retired',
]

export const occupationOptions = [
  'Accountant',
  'Software Engineer',
  'Teacher',
  'Doctor',
  'Lawyer',
  'Business Owner',
  'Consultant',
  'Manager',
  'Sales Representative',
  'Marketing Specialist',
  'Other',
]

export const purposeOptions = [
  'Family Support',
  'Gift',
  'Savings Purposes',
  'Buying Property',
  'Business purposes',
  'Education',
]

export const provinceOptions = [
  { value: 'ab', label: 'Alberta' },
  { value: 'bc', label: 'British Columbia' },
  { value: 'mb', label: 'Manitoba' },
  { value: 'nb', label: 'New Brunswick' },
  { value: 'nl', label: 'Newfoundland and Labrador' },
  { value: 'ns', label: 'Nova Scotia' },
  { value: 'nt', label: 'Northwest Territories' },
  { value: 'nu', label: 'Nunavut' },
  { value: 'on', label: 'Ontario' },
  { value: 'pe', label: 'Prince Edward Island' },
  { value: 'qc', label: 'Quebec' },
  { value: 'sk', label: 'Saskatchewan' },
  { value: 'yt', label: 'Yukon' },
]
export type SignUpStep =
  | 'email'
  | 'phone'
  | 'verify-phone'
  | 'personal-info'
  | 'occupation'
  | 'additional-info'
  | 'additional-info-2'
  | 'start-kyc'
